import { ref } from '@nuxtjs/composition-api';
const isTaboolaLoaded = ref(false);
export const initializeTaboolaHP4U = (adTags) => {
  if (!isTaboolaLoaded.value) {
    adTags.script.push({
      hid: 'taboolaHP4ULoader',
      innerHTML: `
        window._taboola = window._taboola || [];
        _taboola.push({homepage: 'auto'});
        !function (e, f, u, i) {
            if (!document.getElementById(i)) {
                e.async = 1;
                e.src = u;
                e.id = i;
                f.parentNode.insertBefore(e, f);
            }
        }
        (document.createElement('script'),
            document.getElementsByTagName('script')[0],
            '//cdn.taboola.com/libtrc/onedio/loader.js',
            'tb_loader_script');
        if (window.performance && typeof window.performance.mark == 'function') {
            window.performance.mark('tbl_ic');
        }
        `,
      callback: () => {
        isTaboolaLoaded.value = true;
      },
    });
    adTags.script.push({
      hid: 'taboolaHP4UNewsroom',
      innerHTML: `
      window._newsroom = window._newsroom || [];
      if(!window.isTaboolaNewsroomLoaded) {
        window._newsroom.push({pageTemplate: 'home'});
        window._newsroom.push({pageDashboard: 'home'});
        window._newsroom.push('auditClicks');
        window._newsroom.push('trackPage');
        window.isTaboolaNewsroomLoaded = true;
        !function (e, f, u) {
            e.async = 1;
            e.src = u;
            f.parentNode.insertBefore(e, f);
        }(document.createElement('script'),
                document.getElementsByTagName('script')[0], '//c2.taboola.com/nr/onedio/newsroom.js');
      }
        `,
    });
    adTags.__dangerouslyDisableSanitizersByTagID.taboolaHP4ULoader = ['innerHTML'];
    adTags.__dangerouslyDisableSanitizersByTagID.taboolaHP4UNewsroom = ['innerHTML'];
  }
};
